import React from "react";
import "@/App.css";
import "./styles/main.css";
import "./styles/additional.css";
import "./styles/forms.css";
import "./styles/admin.css";
import "./styles/presentation.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from './components/ui/sonner';

// Components
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

// Pages
import Home from "./pages/Home";
import Presentation from "./pages/Presentation";
import Revitalisation from "./pages/Revitalisation";
import PiedsMains from "./pages/PiedsMains";
import MereFille from "./pages/MereFille";
import FemmeEnceinte from "./pages/FemmeEnceinte";
import Detente from "./pages/Detente";
import BeauteRegard from "./pages/BeauteRegard";
import Anniversaire from "./pages/Anniversaire";
import Reservation from "./pages/Reservation";
import ReservationSuccess from "./pages/ReservationSuccess";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/presentation" element={<Presentation />} />
            <Route path="/revitalisation" element={<Revitalisation />} />
            <Route path="/pieds-mains" element={<PiedsMains />} />
            <Route path="/mere-fille" element={<MereFille />} />
            <Route path="/femme-enceinte" element={<FemmeEnceinte />} />
            <Route path="/detente" element={<Detente />} />
            <Route path="/beaute-regard" element={<BeauteRegard />} />
            <Route path="/anniversaire" element={<Anniversaire />} />
            <Route path="/reservation" element={<Reservation />} />
            <Route path="/reservation/success" element={<ReservationSuccess />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<Admin />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
